export const geoTypes = [
	{key: "ltla", label: "Local authority (lower tier)"},
	{key: "utla", label: "Local authority (upper tier)"},
	{key: "cty", label: "County"},
	{key: "mcty", label: "Metropolitan county"},
	{key: "cauth", label: "Combined authority"},
	{key: "rgn", label: "Region"},
	{key: "ctry", label: "Country"},
	{key: "uk", label: "United Kingdom"}
];
export const countries = [
  {key: "E", label: "England"},
  {key: "N", label: "Northern Ireland"},
  {key: "S", label: "Scotland"},
  {key: "W", label: "Wales"}
];
export const path = "./data/topo.json";
export const style = "https://bothness.github.io/ons-basemaps/data/style-esri.json";